export const defaultKeys: { [key: string]: number } = {
  KEY_1: 49,
  KEY_2: 50,
  KEY_3: 51,
  KEY_4: 52,
  BACKSPACE: 8,
  MEDIA_PLAY_PAUSE: 32,
  BRACKET_LEFT: 219,
  BRACKET_RIGHT: 221,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
}

export const tizenKeys: { [key: string]: number } = {
  ...defaultKeys,
  BACK: 10009,
  CHANNEL_UP: 427,
  CHANNEL_DOWN: 428,
  MEDIA_PLAY_PAUSE: 10252,
  MEDIA_PLAY: 415,
  MEDIA_PAUSE: 19,
  MEDIA_STOP: 413,
  MEDIA_FAST_FORWARD: 417,
  MEDIA_REWIND: 412,
  EXIT: 10182,
  COLOR_RED: 403,
  COLOR_GREEN: 404,
  COLOR_YELLOW: 405,
  COLOR_BLUE: 406,
  INFO: 457,
  E_MANUAL: 10146,
}

export const webosKeys: { [key: string]: number } = {
  ...defaultKeys,
  BACK: 461,
  CHANNEL_UP: 33,
  CHANNEL_DOWN: 34,
  MEDIA_PLAY: 415,
  MEDIA_PAUSE: 19,
  MEDIA_STOP: 413,
  MEDIA_FAST_FORWARD: 417,
  MEDIA_REWIND: 412,
  COLOR_RED: 403,
  COLOR_GREEN: 404,
  COLOR_YELLOW: 405,
  COLOR_BLUE: 406,
}

export const fireosKeys: { [key: string]: number } = {
  BACK: 27,
  MEDIA_PLAY_PAUSE: 179,
  MEDIA_FAST_FORWARD: 228,
  MEDIA_REWIND: 227,
}

export const tizenKeyNames: string[] = [
  'ChannelUp',
  'ChannelDown',
  'MediaPlay',
  'MediaPause',
  'MediaStop',
  'MediaPlayPause',
  'MediaFastForward',
  'MediaRewind',
  'ColorF0Red',
  'ColorF1Green',
  'ColorF2Yellow',
  'ColorF3Blue',
  'Info',
  'E-Manual',
]
